export { BreadcrumbComponent as Breadcrumb } from './component';



// WEBPACK FOOTER //
// ./src/components/organisms/breadcrumb/index.tsx